(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabBtns = document.querySelectorAll('.faq-tab-btn');
    const gridContents = document.querySelectorAll('.faq-grid-content');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const tabName = btn.getAttribute('data-tab');

        tabBtns.forEach(b => b.classList.remove('active'));
        gridContents.forEach(content => content.classList.remove('active'));

        btn.classList.add('active');
        document.querySelector(`[data-content="${tabName}"]`).classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slider"] && !Shopify.designMode) return;
  try {
    
/**
 * Optimized Slideshow with Touch/Drag Support
 * Features: Auto-playing, draggable slides, responsive, navigation arrows, and video controls
 */
(function () {
  // Configuration - can be customized as needed
  const AUTO_PLAY_INTERVAL = 5000; // milliseconds
  const TRANSITION_DURATION = 300; // milliseconds
  const DRAG_THRESHOLD = 50; // minimum pixels to trigger slide change
  const RESISTANCE_FACTOR = 0.3; // resistance when dragging past edges

  // SVG icons for mute/unmute buttons
  const MUTE_SVG = `<svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M11 5L6 9H2v6h4l5 4V5z"/>
    <path d="M23 9l-6 6m0-6l6 6"/>
  </svg>`;

  const UNMUTE_SVG = `<svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M11 5L6 9H2v6h4l5 4V5z"/>
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07M18.07 5.93a10 10 0 0 1 0 14.14"/>
  </svg>`;

  // State variables
  let currentIndex = 0;
  let startX, startY;
  let startTranslate,
    dragDistance = 0;
  let isDragging = false;
  let dragStartTime;
  let autoplayInterval;
  let isPaused = false;
  let clickPrevented = false;
  let isVerticalScroll = false;

  // DOM elements - initialize after DOM is loaded
  let slides, track, slidesContainer;
  let totalSlides;

  /**
   * Initialize the slideshow
   */
  function initSlideshow() {
    // Get DOM elements
    track = document.querySelector(".slideshow-track");
    if (!track) return; // Exit if no slideshow on page

    slides = track.querySelectorAll(".slide");
    totalSlides = slides.length;
    slidesContainer = track.parentElement;

    if (totalSlides < 2) return; // No need for slideshow with 0 or 1 slides

    // Set up slideshow
    createNavigationArrows();
    initDragFunctionality();
    updateSlidePosition(false);
    startAutoplay();

    // Add resize listener for responsive behavior
    window.addEventListener("resize", () => updateSlidePosition(false));
  }

  /**
   * Create and append navigation arrows
   */
  function createNavigationArrows() {
    // Create arrow elements
    const leftArrow = document.createElement("button");
    leftArrow.className = "nav-arrow left-arrow";
    leftArrow.innerHTML = "&#10094;";
    leftArrow.setAttribute("aria-label", "Previous slide");
    leftArrow.addEventListener("click", () => plusSlides(-1));

    const rightArrow = document.createElement("button");
    rightArrow.className = "nav-arrow right-arrow";
    rightArrow.innerHTML = "&#10095;";
    rightArrow.setAttribute("aria-label", "Next slide");
    rightArrow.addEventListener("click", () => plusSlides(1));

    // Append to container
    slidesContainer.appendChild(leftArrow);
    slidesContainer.appendChild(rightArrow);

    // Add styling
    addStyles();
  }

  /**
   * Add CSS styles for the slideshow
   */
  function addStyles() {
    if (document.getElementById("slideshow-styles")) return;

    const style = document.createElement("style");
    style.id = "slideshow-styles";
    style.textContent = `
      .nav-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background-color: rgba(0, 0, 0, 0.3);
        color: white;
        border: none;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        font-size: 18px;
        cursor: pointer;
        z-index: 0;
        transition: background-color 0.3s;
      }
      .nav-arrow:hover {
        background-color: rgba(0, 0, 0, 0.6);
      }
      .left-arrow {
        left: 10px;
      }
      .right-arrow {
        right: 10px;
      }
      .slideshow-track {
        will-change: transform;
        touch-action: pan-y;
        cursor: grab;
      }
      .slideshow-track:active {
        cursor: grabbing;
      }
      
      /* Video controls */
      .video-controls {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 20;
        pointer-events: auto !important;
      }
      .mute-button, .unmute-button {
        background-color:#fff;
        border: none;
        border-radius: 0px;
        padding: 8px;
        cursor: pointer;
        transition: background-color 0.3s;
        z-index: 21;
        pointer-events: auto !important;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .mute-button:hover, .unmute-button:hover {
        background-color:#fff;
      }
      .mute-button svg, .unmute-button svg {
        width: 24px;
        height: 24px;
        pointer-events: none;
      }
      
      /* Hide default video controls */
      .custom-video-controls::-webkit-media-controls {
        display: none !important;
      }
      .custom-video-controls::-webkit-media-controls-panel {
        display: none !important;
      }
      .custom-video-controls::-webkit-media-controls-play-button {
        display: none !important;
      }
      .custom-video-controls::-webkit-media-controls-volume-slider {
        display: none !important;
      }
      .custom-video-controls::-webkit-media-controls-mute-button {
        display: none !important;
      }
      .custom-video-controls::-webkit-media-controls-timeline {
        display: none !important;
      }
      .custom-video-controls::-webkit-media-controls-current-time-display {
        display: none !important;
      }
      
      /* Slide positioning */
      .slide {
        position: relative;
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * Change slide by a specific number of positions
   */
  function plusSlides(n) {
    currentIndex = (currentIndex + n + totalSlides) % totalSlides;
    updateSlidePosition();
  }

  /**
   * Update slide position with optional animation
   */
  function updateSlidePosition(animate = true) {
    if (!track) return;

    const slideWidth = slides[0].offsetWidth;
    const translateX = -currentIndex * slideWidth;

    track.style.transition = animate
      ? `transform ${TRANSITION_DURATION}ms ease-out`
      : "none";
    track.style.transform = `translateX(${translateX}px)`;
  }

  /**
   * Prevent link clicks during dragging
   */
  function handleLinkClicks() {
    const links = track.querySelectorAll("a");

    links.forEach((link) => {
      link.addEventListener("click", function (e) {
        if (clickPrevented) {
          e.preventDefault();
          clickPrevented = false;
        }
      });

      link.addEventListener("mousedown", function (e) {
        e.preventDefault();
      });
    });
  }

  /**
   * Initialize drag functionality
   */
  function initDragFunctionality() {
    track.addEventListener("mousedown", startDrag);
    document.addEventListener("mousemove", drag, { passive: false });
    document.addEventListener("mouseup", endDrag);

    track.addEventListener("touchstart", startDrag, { passive: true });
    document.addEventListener("touchmove", drag, { passive: false });
    document.addEventListener("touchend", endDrag);

    handleLinkClicks();

    slidesContainer.addEventListener("mouseenter", pauseAutoplay);
    slidesContainer.addEventListener("mouseleave", resumeAutoplay);
  }

  /**
   * Start the drag operation
   */
  function startDrag(e) {
    if (e.target.tagName === "BUTTON") return;

    isDragging = true;
    clickPrevented = false;
    isVerticalScroll = false;

    if (e.type.includes("touch")) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    } else {
      startX = e.clientX;
      startY = e.clientY;
      e.preventDefault(); // Only prevent default for mouse events
    }

    startTranslate = getTranslateX(track);
    dragStartTime = Date.now();
    dragDistance = 0;

    track.style.transition = "none";
    pauseAutoplay();
  }

  /**
   * Handle the drag movement
   */
  function drag(e) {
    if (!isDragging) return;

    let currentX, currentY;

    if (e.type.includes("touch")) {
      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;
    } else {
      currentX = e.clientX;
      currentY = e.clientY;
    }

    // Calculate horizontal and vertical distances
    const deltaX = currentX - startX;
    const deltaY = currentY - startY;

    // If we haven't determined scroll direction yet
    if (!isVerticalScroll) {
      // Check if movement is more vertical than horizontal
      if (Math.abs(deltaY) > Math.abs(deltaX) * 1.5) {
        isVerticalScroll = true;
        isDragging = false;
        return; // Allow normal vertical scrolling
      }

      // If horizontal movement is significant, prevent vertical scroll
      if (Math.abs(deltaX) > 10) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }
    }

    // If this is a vertical scroll, exit
    if (isVerticalScroll) {
      return;
    }

    // Process horizontal drag
    dragDistance = deltaX;

    if (Math.abs(dragDistance) > 10) {
      clickPrevented = true;
      if (e.cancelable) {
        e.preventDefault();
      }
    }

    const slideWidth = slides[0].offsetWidth;
    const minTranslate = -(totalSlides - 1) * slideWidth;
    let newTranslate = startTranslate + dragDistance;

    if (newTranslate > 0) {
      newTranslate = newTranslate * RESISTANCE_FACTOR;
    } else if (newTranslate < minTranslate) {
      newTranslate =
        minTranslate + (newTranslate - minTranslate) * RESISTANCE_FACTOR;
    }

    track.style.transform = `translateX(${newTranslate}px)`;
  }

  /**
   * End the drag operation
   */
  function endDrag() {
    if (!isDragging) return;

    isDragging = false;

    // If this was determined to be a vertical scroll, do nothing
    if (isVerticalScroll) {
      return;
    }

    const slideWidth = slides[0].offsetWidth;
    const dragDuration = Date.now() - dragStartTime;

    if (dragDuration < 200 && Math.abs(dragDistance) < 10) {
      clickPrevented = false;
    } else {
      const velocity = Math.abs(dragDistance) / dragDuration;
      const direction = dragDistance > 0 ? -1 : 1;
      const isFlick = velocity > 0.5;

      if (Math.abs(dragDistance) >= DRAG_THRESHOLD || isFlick) {
        plusSlides(direction);
      } else {
        updateSlidePosition();
      }
    }

    if (!isPaused) {
      resumeAutoplay();
    }

    setTimeout(() => {
      clickPrevented = false;
    }, 100);
  }

  /**
   * Get current translateX value
   */
  function getTranslateX(element) {
    const style = window.getComputedStyle(element);
    try {
      const matrix = new WebKitCSSMatrix(style.transform);
      return matrix.m41;
    } catch (e) {
      const matrix = style.transform.match(/matrix.*\((.+)\)/);
      if (matrix && matrix[1]) {
        return parseFloat(matrix[1].split(", ")[4]);
      }
      return 0;
    }
  }

  /**
   * Pause autoplay
   */
  function pauseAutoplay() {
    isPaused = true;
    clearInterval(autoplayInterval);
  }

  /**
   * Resume autoplay
   */
  function resumeAutoplay() {
    isPaused = false;
    clearInterval(autoplayInterval);
    startAutoplay();
  }

  /**
   * Start autoplay
   */
  function startAutoplay() {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => {
      if (!isDragging && !isPaused) {
        plusSlides(1);
      }
    }, AUTO_PLAY_INTERVAL);
  }

  /**
   * Setup video elements
   */
  function setupVideos() {
    const isMobile = window.matchMedia("(max-width: 760px)").matches;

    document
      .querySelectorAll(".desktopvideo, .mobilevideo")
      .forEach((video) => {
        video.removeAttribute("controls");
        video.controls = false;
        video.loop = true;
      });

    document
      .querySelectorAll(".desktopvideo, .mobilevideo")
      .forEach((video) => {
        if (isMobile && video.classList.contains("mobilevideo")) {
          video.classList.remove("hidden");
          video.style.display = "block";
        } else if (!isMobile && video.classList.contains("desktopvideo")) {
          video.classList.remove("hidden");
          video.style.display = "block";
        } else {
          video.classList.add("hidden");
          video.style.display = "none";
        }
      });

    setTimeout(() => {
      document
        .querySelectorAll(
          ".desktopvideo:not(.hidden), .mobilevideo:not(.hidden)"
        )
        .forEach((video) => {
          createMuteButton(video);
          setupVideoObserver(video);
          video.addEventListener("play", function () {
            pauseAutoplay();
          });
        });
    }, 100);
  }

  /**
   * Create mute button with SVG icons
   */
  function createMuteButton(video) {
    if (!video) return;

    const existingControls = video.parentNode.querySelector(".video-controls");
    if (existingControls) existingControls.remove();

    const controlContainer = document.createElement("div");
    controlContainer.classList.add("video-controls");

    const muteButton = document.createElement("button");
    muteButton.innerHTML = video.muted ? UNMUTE_SVG : MUTE_SVG;
    muteButton.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
    muteButton.classList.add(video.muted ? "unmute-button" : "mute-button");

    muteButton.style.pointerEvents = "auto";
    muteButton.style.zIndex = "30";

    muteButton.onclick = function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      video.muted = !video.muted;
      video.loop = true;
      this.innerHTML = video.muted ? UNMUTE_SVG : MUTE_SVG;
      this.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
      this.className = video.muted ? "unmute-button" : "mute-button";

      if (!video.muted && video.paused) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            video.muted = true;
            video.loop = true;
            this.innerHTML = UNMUTE_SVG;
            this.setAttribute("aria-label", "Unmute");
            this.className = "unmute-button";
          });
        }
      }

      return false;
    };

    controlContainer.appendChild(muteButton);
    const slideContainer = findParentWithClass(video, "slide");
    if (slideContainer) {
      slideContainer.appendChild(controlContainer);
    } else {
      video.parentNode.appendChild(controlContainer);
    }
  }

  /**
   * Find parent element with class
   */
  function findParentWithClass(element, className) {
    let current = element;
    while (current) {
      if (current.classList && current.classList.contains(className)) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  /**
   * Setup video intersection observer
   */
  function setupVideoObserver(video) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (video.getAttribute("data-was-muted") === "true") {
              video.muted = true;
            } else if (video.getAttribute("data-was-muted") === "false") {
              video.muted = false;
            }
            video.loop = true;
            updateMuteButton(video);
          } else {
            video.setAttribute(
              "data-was-muted",
              video.muted ? "true" : "false"
            );
            video.muted = true;
            video.loop = true;
            updateMuteButton(video);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(video);
  }

  /**
   * Update mute button state
   */
  function updateMuteButton(video) {
    const slideContainer = findParentWithClass(video, "slide");
    const controlContainer = slideContainer
      ? slideContainer.querySelector(".video-controls")
      : video.parentNode.querySelector(".video-controls");

    if (!controlContainer) return;
    const muteButton = controlContainer.querySelector(
      ".mute-button, .unmute-button"
    );
    if (!muteButton) return;

    muteButton.innerHTML = video.muted ? UNMUTE_SVG : MUTE_SVG;
    muteButton.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
    muteButton.className = video.muted ? "unmute-button" : "mute-button";
  }

  /**
   * Handle device changes
   */
  function handleDeviceChange() {
    const isMobile = window.matchMedia("(max-width: 760px)").matches;

    document.querySelectorAll(".video-controls").forEach((control) => {
      control.remove();
    });

    document
      .querySelectorAll(".desktopvideo, .mobilevideo")
      .forEach((video) => {
        video.classList.add("hidden");
        video.style.display = "none";
        video.loop = true;

        if (isMobile && video.classList.contains("mobilevideo")) {
          video.classList.remove("hidden");
          video.style.display = "block";
        } else if (!isMobile && video.classList.contains("desktopvideo")) {
          video.classList.remove("hidden");
          video.style.display = "block";
        }
      });

    setTimeout(() => {
      document
        .querySelectorAll(
          ".desktopvideo:not(.hidden), .mobilevideo:not(.hidden)"
        )
        .forEach((video) => {
          createMuteButton(video);
        });
    }, 100);
  }

  // Initialize on DOM ready
  document.addEventListener("DOMContentLoaded", function () {
    initSlideshow();

    setTimeout(() => {
      setupVideos();
    }, 500);

    // Handle window resize for responsive videos
    window.addEventListener("resize", function () {
      handleDeviceChange();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
